import React from "react";
export const DistributorContext = React.createContext({});
